import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './component/scrollToTop/ScrollToTop';
import 'bootstrap/dist/css/bootstrap.min.css';

// Home Pages Import
import PaginaInicial from './pages/PaginaInicial';

// Service 
import ServiceDetailsEletricidade from './pages/ServiceDetailsEletricidade';
import ServiceDetailsEnergieRenouvelable from './pages/ServiceDetailsEnergie';
import ServiceDetailsInformatique from './pages/ServiceDetailsInformatique';

// Pages 
import Contact from './pages/Contact';
import ErrorPage from './pages/404';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';

import ServiceCourantFort from './pages/Electricite/Service_CourantFort'
import ServiceCourantFaible from './pages/Electricite/Service_CourantFaible'
import ServiceAudiovisuel from './pages/Electricite/Service_Audiovisuel'
import ServiceSecurite from './pages/Electricite/Service_Securite'

import ServiceGestiondenergie from './pages/EnergieRenouvelable/Service_Gestiondenergie'
import ServiceStockagedenergie from './pages/EnergieRenouvelable/Service_Stockagedenergie'
import ServiceProductiondenergie from './pages/EnergieRenouvelable/Service_Productiondenergie'
import ServiceMaintenance from './pages/EnergieRenouvelable/Service_Maintenance'

import ServiceDeveloppement from './pages/Informatique/Service_Developpement'
import ServiceCreativeBranding from './pages/Informatique/Service_Creative_Branding'
import ServiceItSolutions from './pages/Informatique/Service_ItSolutions'

// Css Import
import './assets/scss/app.scss';


const App = () => {
	return (
		<Router>
			<ScrollToTop>
				<Routes>
					<Route path={"/"} element={<PaginaInicial />} />

					<Route path={"/contact"} element={<Contact />} />
					<Route path={"/404"} element={<ErrorPage />} />

					{/* servicos eletricidade */}
					<Route path={"/service-Courant_Fort"} element={<ServiceCourantFort />} />
					<Route path={"/service-Courant_Faible"} element={<ServiceCourantFaible />} />
					<Route path={"/service-Audiovisuel"} element={<ServiceAudiovisuel />} />
					<Route path={"/service-Securite"} element={<ServiceSecurite />} />
					{/* servicos energias renovaveis */}
					<Route path={"/service-Gestiondenergie"} element={<ServiceGestiondenergie />} />
					<Route path={"/service-Stockagedenergie"} element={<ServiceStockagedenergie />} />
					<Route path={"/service-Productiondenergie"} element={<ServiceProductiondenergie />} />
					<Route path={"/service-Maintenance"} element={<ServiceMaintenance />} />

					{/* servicos informaticos */}
					<Route path={"/service-Developpement"} element={<ServiceDeveloppement />} />
					<Route path={"/service-Creative-Branding"} element={<ServiceCreativeBranding />} />
					<Route path={"/service-ServiceItSolutions"} element={<ServiceItSolutions />} />

					{/* Service */}
					<Route path={"/service-details/Eletricite"} element={<ServiceDetailsEletricidade />} />
					<Route path={"/service-details/Energie_Renouvelable"} element={<ServiceDetailsEnergieRenouvelable />} />
					<Route path={"/service-details/Informatique"} element={<ServiceDetailsInformatique />} />


					{/* Pages  */}
					<Route path={"/privacy-policy"} element={<PrivacyPolicy />} />
					<Route path={"/terms-use"} element={<TermsOfUse />} />

					<Route path="*" element={<ErrorPage />} />
				</Routes>
			</ScrollToTop>
		</Router>
	)
}

export default App;
